module.exports = {

  title: 'Vue Admin Template',

  /**
 * @type {boolean} true | false
 * @description Whether need tagsView
 */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
